import React, { useState, useEffect } from "react";
import { useMediaQuery, Typography, Box, LinearProgress } from "@mui/material";
import {
  Timeline,
  TimelineItem,
  // TimelineOppositeContent,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
} from "@mui/lab";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import AlbumIcon from '@mui/icons-material/Album';
import { TaskmgmtServiceURL } from "../../../config/config";
import { ServiceName } from "../../../constants";
import { getApiCall } from "../../../services/apiHelper";
import dayjs from "dayjs";
import { AuditLog } from "../../../all_Interfaces";
import { useAppSelector } from "../../../redux/hooks";


const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

type audit = {
  id: string | undefined | null;
  appraisalId: string | undefined | null;
  status: string | undefined | null;
  taskComments: string | undefined | null;
  lastModified: Date;
  created: Date;
  approverName: string | undefined | null;
  taskStatus: string | undefined | null;
};

const AuditControl = (props) => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading,setLoading] = useState<boolean>(false);
  const appraisalId = "bee6afe0-0e86-4503-998d-a6471b9da5be";
  const auditTrail:AuditLog[] = useAppSelector(
    (state) => state.auditLog.data
  );

  

  useEffect(() => {
   
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {/* <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #ccc",
          padding: "10px",
          overflowY: "auto",
        }}
      > */}
      <Box sx={{ width: "100%", py: 0, px: 0 }}>
        <Timeline 
        sx={{
          [`& .${timelineOppositeContentClasses.root}`]: {
            flex: 0.5,
            fontSize: "0.6em",
          },
        }}
        >

          {auditTrail?.map((item) => (
            <TimelineItem key={item.id} sx={{ py: 0, px: 0, }}>
              <TimelineOppositeContent>
                <Typography color="textSecondary">
                  {dayjs(item.created ).format('MMM-DD-YYYY HH:mm:ss')}
                </Typography>
              </TimelineOppositeContent>
              <TimelineSeparator >
                <TimelineDot color="secondary" sx={{ bgcolor: "#2b8818" }}>
                  <AlbumIcon />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Typography color="textSecondary" variant="caption">
                  {item.status}
                </Typography>
                {item.approverName && (<Typography>{item.approverName}</Typography>)}
                {item.taskComments && (<Typography>{item.taskComments.replace(/<[^>]+>/g, '')}</Typography>)}
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Box>

      {/* </Box> */}
    </ThemeProvider>
  );
};

export default AuditControl;
